// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
import { RtcTokenBuilder, RtmTokenBuilder } from "agora-access-token";
import LocalStorage, { LocalStorageKey } from "../local-storage/local-storage";

export enum ClientRole {
  PUBLISHER = 1,
  SUBSCRIBER = 2,
}

export const appID = process.env.REACT_APP_AGORA_APP_ID || "";
const appCertificate = process.env.REACT_APP_AGORA_CERTIFICATE_ID;
const expirationTimeInSeconds = 43200;
const currentTimestamp = Math.floor(Date.now() / 1000);
const privilegeExpiredTs = currentTimestamp + expirationTimeInSeconds;

export const getUniqueID = () => {
  const uniqueId = LocalStorage.get(LocalStorageKey.userId);
  if (uniqueId) {
    return Number(uniqueId);
  }
  const min = 1;
  const max = 4294967295; // max user id of agora 2^32-1
  const newUniqueID = `${Math.floor(
    Math.random() * (max - min + 1) + min
  )}${Date.now()}`;
  LocalStorage.set(LocalStorageKey.userId, newUniqueID);
  return Number(newUniqueID);
};

export const generateRTCToken = (
  clientRole: ClientRole,
  clientId: number,
  channelName: string
) => {
  if (!appID || !appCertificate) {
    return null;
  }
  const rtcToken = RtcTokenBuilder.buildTokenWithUid(
    appID,
    appCertificate,
    channelName,
    clientId,
    clientRole,
    privilegeExpiredTs
  );
  return rtcToken;
};

export const generateRTMToken = (clientRole: ClientRole, clientId: string) => {
  if (!appID || !appCertificate) {
    return null;
  }
  const rtmToken = RtmTokenBuilder.buildToken(
    appID,
    appCertificate,
    clientId,
    clientRole,
    privilegeExpiredTs
  );
  return rtmToken;
};
